import { computed, onMounted } from 'vue';
import { t } from '/@/utils/i18n';
import { PollingTime } from '/@/enums/appEnum';
import { Modal } from 'ant-design-vue';
import zIndexStyle from '/@/design/zIndex.module.less';

export function useAppVersion() {
  let currentHtml: Undefinedable<string> = undefined;

  onMounted(() => {
    getHtml();
  });

  const isLocalDevelopment = computed(() => {
    return !!window.location.port || window.location.href.includes('localhost');
  });
  function getHtml() {
    setTimeout(async () => {
      if (!isLocalDevelopment.value) {
        try {
          const res = await fetch('/', { cache: 'no-cache' });
          const resp = await res.text();
          if (currentHtml == undefined) {
            currentHtml = resp;
            getHtml();
          } else {
            if (currentHtml !== resp) {
              Modal.confirm({
                zIndex: zIndexStyle.maskZIndex,
                title: () => t('sys.versionTipTitle'),
                content: () => t('sys.versionTipContent'),
                okButtonProps: {
                  type: 'primary',
                  // @ts-ignore
                  style: 'width: 70px',
                },
                cancelButtonProps: {
                  // type: 'link',
                },
                onOk() {
                  window.location.reload();
                },
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onCancel() {},
              });
            } else {
              getHtml();
            }
          }
        } catch (e) {
          getHtml();
        }
      }
    }, PollingTime.lang);
  }
}
